import styled, { css } from "styled-components";
import { theme } from '../../theme'

export const AnnouncementCardWrapper = styled.div`
    background-color: ${theme.colors.mainWhite};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
    ${({ scroll }) =>
    scroll &&
    css`
        height: 21rem;
        overflow: hidden;
      overflow-y: auto;
      ::-webkit-scrollbar {
        
        width: 6px;
      }
      /* Track */
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #7B7C88;
    opacity: 0.7;
    border-radius: 7px;
      }
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.5);
      }
      `}
    
`
export const AnnouncementCardTopSection = styled.div`
  background-color: ${theme.colors.mainWhite};
  display: flex;
  //   justify-content: space-around;
  align-items: center;
  padding: 1.9rem 3.7rem 1.9rem 1.2rem;
  border-bottom: 1px solid rgb(216 216 216 / 37%);
  border-radius: 1.1rem;
`

export const InputContainer = styled.div`
    @media only screen and (max-width: 500px) {
        display: none;
    }
`